import { useTranslation } from 'react-i18next';
import { ListGroup, ListRow, PageHeader } from '@/components/ui';
import { visibleEntries } from '@/lib/routes/logic';
import { ROUTE_LABEL_KEY } from '@/lib/routes/route-labels';
import { useAuthStore } from '@/store/auth';

/**
 * 「我的 → 管理」枢纽页。
 *
 * 工地设置、工地、用户、职位、审计日志这些是低频的配置动作，不该占底部 Tab ——
 * 它们一天可能都用不上一次，而底部五个位置得留给每天要点的东西。
 *
 * 哪几项出现由路由表决定（CR-040，`systemHub` 入口）；这一页本身的门槛是
 * 这几项门槛的并集，所以进得来就至少有一项。页面直接复用网页端的实现。
 * CR-082：一组列表，不再一张一张卡片、不放箭头。
 */
export function SystemPage() {
  const { t } = useTranslation();
  const role = useAuthStore((s) => s.user?.role ?? null);
  const items = visibleEntries(role, 'systemHub');

  return (
    <>
      <PageHeader title={t('settings.system')} description={t('settings.systemHint')} />
      <ListGroup>
        {items.map(({ route }) => (
          <ListRow key={route.id} to={route.path} entry={route.id} title={t(ROUTE_LABEL_KEY[route.id])} />
        ))}
      </ListGroup>
    </>
  );
}
